import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import user from 'legacy/utils/user'

import { createMagicLinkHttpClient } from 'auth/infra/createMagicLinkHttpClient'

export function createShipperHttpClient() {
  if (user.isLoggedIn()) {
    return new HttpClient(`${API_URL}api/v2/`)
  }

  return createMagicLinkHttpClient()
}
